import React, {useState} from 'react'
import Page from 'organization/Event/TemplateEditor/Page'
import SuccessAlert from 'lib/ui/alerts/SuccessAlert'
import ErrorAlert from 'lib/ui/alerts/ErrorAlert'
import StatusSelect from 'organization/Event/ImageEntries/StatusSelect'
import ImageWaterfallConfig from 'organization/Event/ImageEntries/ImageWaterfallConfig'
import Grid from '@material-ui/core/Grid'
import {useImageEntries} from 'organization/Event/ImageEntriesProvider'
import ImageEntryCard from 'organization/Event/ImageEntries/ImageEntryCard'
import PageLimitSelect from 'organization/Event/ImageEntries/PageLimitSelect'
import Pagination from 'organization/Event/ImageEntries/Pagination'
import {useToggle} from 'lib/toggle'
import SelectedImage from 'Event/ImageWaterfall/SelectedImage'
import {ImageEntry} from 'organization/Event/ImageEntriesProvider'
import ExportButton from './ExportButton'
import styled from 'styled-components'
import Button from 'lib/ui/Button'
import {FeaturesBreadcrumbs} from 'organization/Event/Page/PageBreadcrumbs'
import DeleteAllImagesButton from 'organization/Event/ImageEntries/DeleteAllImagesButton'
import {Controller, useForm} from 'react-hook-form'
import {EnabledSwitch} from 'lib/ui/form/Switch'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {onChangeCheckedHandler} from 'lib/dom'
import {useTemplate} from 'Event/TemplateProvider'

export default function ImageEntries() {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [successMessage, setSuccessMessage] = useState<string | null>(null)
  const {
    flag: showingWaterfallConfig,
    toggle: toggleWaterfallConfig,
  } = useToggle()
  const {control} = useForm()
  const template = useTemplate()
  const {imageWaterfall: current} = template
  const update = useSaveTemplate()
  const toggleImageEntriesEnabled = (imageEntriesEnabled: boolean) => {
    update({
      imageWaterfall: {
        isVisible: imageEntriesEnabled,
      },
    })
  }

  return (
    <>
      <ImageWaterfallConfig
        isVisible={showingWaterfallConfig}
        onClose={toggleWaterfallConfig}
      />
      <FeaturesBreadcrumbs page="Image Entries">
        <Page
          toolbarItems={
            <>
              <Controller
                name="isVisible"
                control={control}
                defaultValue={current.isVisible}
                render={({value, onChange}) => (
                  <StyledEnabledSwitch
                    checked={value}
                    onChange={onChangeCheckedHandler((checked) => {
                      onChange(checked)
                      toggleImageEntriesEnabled(checked)
                    })}
                    aria-label="toggle image waterfall page"
                  />
                )}
              />
              <SettingsButton
                variant="outlined"
                color="primary"
                onClick={toggleWaterfallConfig}
                aria-label="page settings"
                disabled={!current.isVisible}
              >
                Page Settings
              </SettingsButton>
              <ExportButton
                onError={setErrorMessage}
                onSuccess={setSuccessMessage}
              />
            </>
          }
          rightToolbarItems={
            <>
              <DeleteAllImagesButton
                onError={setErrorMessage}
                onSuccess={setSuccessMessage}
              />
            </>
          }
        >
          <Container>
            <ErrorAlert onClose={() => setErrorMessage(null)}>
              {errorMessage}
            </ErrorAlert>
            <SuccessAlert onClose={() => setSuccessMessage(null)}>
              {successMessage}
            </SuccessAlert>
            <StatusSelect />
            <Entries />
            <Grid container justify="center">
              <PageLimitSelect />
              <Pagination />
            </Grid>
          </Container>
        </Page>
      </FeaturesBreadcrumbs>
    </>
  )
}

function Entries() {
  const {entries, attendeeNames} = useImageEntries()

  const [selected, setSelected] = useState<ImageEntry | null>(null)

  const isEmpty = entries.length === 0
  if (isEmpty) {
    return <div>No Image Entries Available</div>
  }

  return (
    <Grid container wrap="wrap">
      {entries.map((entry) => (
        <ImageEntryCard
          key={entry.id}
          entry={entry}
          attendeeName={attendeeNames[entry.attendee_id]}
          setSelected={setSelected}
        />
      ))}
      <SelectedImage
        appBarPresent
        selected={selected}
        onClose={() => setSelected(null)}
      />
    </Grid>
  )
}

const SettingsButton = styled(Button)`
  margin-right: ${(props) => props.theme.spacing[2]};
`
const StyledEnabledSwitch = styled(EnabledSwitch)`
  margin-bottom: 0;
`
const Container = styled.div`
  padding: 16px 60px 20px;
`
